import React from 'react';
import { Authorisations } from '../client/views/admin/Autorisations';
import { EditCampagne } from '../client/views/admin/Campagne';
import { Campagnes } from '../client/views/admin/Campagnes';
import Zones from '../client/views/admin/CLIENT_Zones';
import { EditFranchise } from '../client/views/admin/Franchise';
import { Franchises } from '../client/views/admin/Franchises';
import { Parametres } from '../client/views/admin/Parametres';
import { Projets } from '../client/views/admin/Projets';
import { Reviews } from '../client/views/admin/Reviews';
import { Submissions } from '../client/views/admin/Submissions';
import { Territoires } from '../client/views/admin/Territoires';
import { EditTerritory } from '../client/views/admin/Territory';
import { Tracker } from '../client/views/admin/Tracking/Tracker';
import { Auth } from '../client/views/Auth';
import { AuthRefuse } from '../client/views/AuthRefuse';
import { AuthSuccess } from '../client/views/AuthSuccess';
import { Campagne } from '../client/views/Campagne';
import { FacebookSoumission } from '../client/views/FacebookSoumission';
import { Home } from '../client/views/Home';
import { MessageSent } from '../client/views/MessageSent';
import { NotFound } from '../client/views/NotFound';
import { PubRedressissement } from '../client/views/pubs/PubRedressissement';
import { Test } from '../client/views/Test';
import { Logout } from '../client/views/Logout';

export interface RouteParams {
    path: string,
    /* specify the path that the frontend must load, if shared accross multiple routes */
    loaderPath?: string,
    component: React.ReactNode,
    protect?: boolean,
    skipLoader?: boolean;
}
export type RouteParamContainer = {
    [index: string]: RouteParams;
};

export let routes: RouteParamContainer = {
    home: {
        path: '/',
        component: <Home />
    },
    admin: {
        path: '/admin',
        component: <Submissions />,
        protect: true
    },
    adminAdministrateurs: {
        path: '/admin/administrateurs',
        component: <Authorisations />,
        loaderPath: '/admin',
        protect: true
    },
    adminFranchises: {
        path: '/admin/franchises',
        component: <Franchises />,
        loaderPath: '/admin',
        protect: true
    },
    adminFranchise: {
        path: '/admin/franchise/:id',
        component: <EditFranchise />,
        protect: true
    },
    adminCampagnes: {
        path: '/admin/campagnes',
        component: <Campagnes />,
        loaderPath: '/admin',
        protect: true
    },
    adminCampagne: {
        path: '/admin/campagne/:id',
        component: <EditCampagne />,
        protect: true
    },
    adminSubmissions: {
        path: '/admin/soumissions',
        component: <Submissions />,
        protect: true
    },
    adminArchivedSubmissions: {
        path: '/admin/archivedsoumissions',
        component: <Submissions archives={true} />,
        protect: true
    },
    adminTerritories: {
        path: '/admin/territoires',
        component: <Territoires />,
        protect: true
    },
    adminTerritoire: {
        path: '/admin/territoire/:id',
        component: <EditTerritory />,
        protect: true
    },
    adminParametres: {
        path: '/admin/parametres',
        component: <Parametres />,
        protect: true
    },
    adminReview: {
        path: '/admin/reviews',
        component: <Reviews />,
        protect: true
    },
    auth: {
        path: '/auth',
        component: <Auth />,
        skipLoader: true
    },
    authRefuse: {
        path: '/auth/refuse',
        component: <AuthRefuse />,
        skipLoader: true
    },
    logOut: {
        path: '/auth/logout',
        component: <Logout />,
    },
    authSuccess: {
        path: '/auth/success',
        component: <AuthSuccess />,
        skipLoader: true
    },
    adminProjets: {
        path: '/admin/projets',
        component: <Projets />,
        protect: true
    },
    adminTracking: {
        path: '/admin/tracking',
        component: <Tracker />,
        protect: true
    },
    messageSent: {
        path: '/messageSent/:hash',
        component: <MessageSent />
    },
    facebookSoumission: {
        path: '/f/gazebo-pieux-intemperies-solidification',
        component: <FacebookSoumission />
    },
    pubRedressement: {
        path: '/f/redressement-stabilisation-maison-pieux-hydrauliques',
        component: <PubRedressissement />
    },
    pubNov2023: {
        path: '/f/fondations-pieux-protech-stables-et-durables',
        component: <Home />
    },
    test: {
        path: '/test',
        component: <Test />,
        protect: true
    },
    notFound: {
        path: '*',
        component: <NotFound />,
        skipLoader: true
    },
    campagne: {
        path: '/campagne/:id',
        component: <Campagne />,
    },
    adminZones: {
        path: '/admin/zones',
        component: <Zones />
    }
};
